import { ContactMail, Person, PersonAdd, LocalPhone, Apartment, LocationCity, Email, Lock, Language } from '@mui/icons-material';
import { Box, FormControl, Grid, TextField, RadioGroup, FormControlLabel, Radio, Button, InputLabel, Select, MenuItem } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import './register.css';
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { getAllCounty, reset as commonReset } from '../../features/common/commonSlice';
import { registerDC, reset as authReset } from '../../features/auth/authSlice';
import * as ld from 'lodash';

import { toast } from 'react-toastify'
import Spinner from '../Layout/Spinner';
import config from '../../utils/Config';
import authService from '../../features/auth/authService';


const EMAIL_NAME_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_NAME_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/;
const NAME_REGEX = /^[A-Za-z]{2,20}$/;
// const PHONE_REGEX = /^[0-9]{0,10}$/;
const PHONE_REGEX = /^\d{3}-\d{3}-\d{4}$/;
const ZIP_REGEX = /^[0-9]{5}$/;

function Register(props) {

    useEffect(() => {
        document.title = props.title;
    }, []);

    const [dfValue, setdfValue] = useState('no');
    const [countyValue, setcountyValue] = useState();
    const [distValue, setDistValue] = useState();
    const [distList, setDistList] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const { countyList, isError: commonIsError, isSuccess: commonIsSuccess, isLoading: commonIsLoading, message: commonMessage } = useSelector(
        (state) => state.common
    )

    let { isError: authIsError, isSuccess: authIsSuccess, isLoading: authIsLoading, message: authMessage } = useSelector(
        (state) => state.auth
    )
    const { register, handleSubmit, formState: { errors }, watch, reset: resetRegiterForm } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            directlyFunded: "no" // Default value for the "gender" radio button group
        }
    });


    useEffect(() => {

        if (countyValue) {
            let filterCounty = countyList.find((val, key) => {
                return val._id === countyValue
            })
            // console.log('countyList', countyList, 'countyList');
            let distFilterList = (filterCounty.districts).filter((val, key) => {
                let currentYearDFVal = val.directlyFunded;

                if (dfValue === 'no' && currentYearDFVal === '0') {
                    return true
                } else if (dfValue === 'yes' && currentYearDFVal === '1') {
                    return true
                } else if (dfValue === 'both') {
                    return true
                } else {
                    return false
                }

            })
            setDistList(distFilterList.length > 0 ? ld.sortBy(distFilterList, ['name']) : []);

        } else {
            setDistList([]);
        }

    }, [dfValue, countyValue])



    useEffect(() => {
        if (commonIsError) {
            console.log(commonMessage)
            toast.error(commonMessage)
            commonIsError = false;
        }

        if (authIsError) {
            toast.error(authMessage);
            authIsError = false;
        }

        if (authIsSuccess) {
            toast.success(authMessage)
            resetRegiterForm()
            setcountyValue('')
            authIsSuccess = false

        }
        dispatch(getAllCounty());

    }, [authIsSuccess, authIsError, authMessage, authIsError, authIsSuccess, authMessage, navigate, dispatch])

    const handleNextPage = () => {
        // dispatch(authReset())
        dispatch(commonReset())
    }

    const handleDFChange = (event) => {
        setdfValue(event.target.value)
    }

    const formatPhoneNumber = (value) => {
        // Remove all non-digit characters
        const cleaned = ('' + value).replace(/\D/g, '');

        // Match and format the number into xxx-xxx-xxxx
        const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (match) {
            const part1 = match[1]; // First three digits
            const part2 = match[2]; // Next three digits
            const part3 = match[3]; // Last four digits
            
            // Construct the formatted string
            return [part1, part2, part3].filter(Boolean).join('-').replace(/-$/, ''); // Remove trailing dash
        }
        return value; // Return unformatted value if no match
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        const formattedValue = formatPhoneNumber(value); // Format the input value
        event.target.value = formattedValue; // Update the input field
    };


    const onSubmit = (userData) => {
        authService.register(userData).then((result) => {
            console.log(result);
            toast.success(result.message ? result.message : "This email address is already associated with an account. Please click “Already a member. Sign in” to log in.")
            
            setTimeout(() => {
                window.location.reload();
            }, 7000);
        }).catch(err => {
            toast.error(err?.response?.data?.message ? err.response.data.message : "Error in registration");
        })
    }

    const onError = () => {
        if (Object.keys(errors).length >= 0) {
            toast.error("At least one field on this form is missing or invalid.");
        }
    };

    const oncountyChange = (event) => {
        console.log("onCountyChange :" + event.target.value)
        setcountyValue(event.target.value)
    }

    function onDistChange(event) {
        console.log(event.target.value)
        setDistValue(event.target.value)
    }

    // Sort the countyList array alphabetically by name
    const sortedCountyList = countyList.slice().sort((a, b) => {
        // Convert names to lowercase for case-insensitive sorting
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });

    // console.log("sortedCountyList " + sortedCountyList);

    return (
        <>
            {(commonIsLoading || authIsLoading) ? <Spinner></Spinner> : ''}
            <form onSubmit={handleSubmit(onSubmit, onError)}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={0} style={{ marginTop: '20px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={5.4}>
                            <div className="contentLeft" style={{ marginTop: "10px" }}>
                                <img src={require('../../assets/images/menuHeader_new.png')} alt="calSchls" className="reg-logo-img" />
                                <div className="logo-sub-title">
                                    <span className="reg-cordinator-portal">CalSCHLS Coordinator Portal</span>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <div className="contentRight">
                                <img src={require('../../assets/images/wested.png')} alt="wested" style={{ height: '90px', width: '375px' }} />
                            </div>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>
                    {/* Registration heading text */}
                    <Grid container spacing={0} style={{ marginTop: '40px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={6}>
                            <div className="contentLeft regcel">
                                <span>Registration for </span>
                                <span style={{ borderBottom: '2px solid #003c68' }}>District</span>
                                <span> Coordinator</span>
                            </div>
                        </Grid>
                        <Grid item xs={4}>
                            <div className="contentRight aaml">
                                <Link to={"/login"} className="signInTxt" onClick={handleNextPage}>
                                    <span>Already a member? Sign in </span>
                                </Link>

                            </div>
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>
                    {/*  form start*/}
                    <Grid container spacing={0} style={{ marginTop: '60px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Person sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="firstName" name="firstName" label="First Name" variant="standard" sx={{ width: '90%' }}
                                    {...register('firstName', { required: true, minLength: 2, maxLength: 20, pattern: NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.firstName && errors.firstName.type === "required" && (
                                <span className="errorClass">Enter <b>first name</b></span>
                            )}
                            {errors.firstName && (errors.firstName.type === "minLength" || errors.firstName.type === "maxLength" || errors.firstName.type === "pattern") && (
                                <span className="errorClass">Last name must be between 2 and 20 characters long, no numbers allowed.</span>
                            )}


                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <PersonAdd sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="lastName" name="lastName" label="Last Name" variant="standard" sx={{ width: '100%' }}
                                    {...register('lastName', { required: true, minLength: 2, maxLength: 20, pattern: NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />

                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.lastName && errors.lastName.type === "required" && (
                                <span className="errorClass">Enter <b>last name</b></span>
                            )}
                            {errors.lastName && (errors.lastName.type === "minLength" || errors.lastName.type === "maxLength" || errors.lastName.type === "pattern") && (
                                <span className="errorClass">Last name must be between 2 and 20 characters long, no numbers allowed.</span>
                            )}
                        </Grid>

                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <ContactMail sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="email" name="email" label="Email" variant="standard" sx={{ width: '90%' }}
                                    {...register('email', { required: true, pattern: EMAIL_NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.email && errors.email.type === "required" && (
                                <span className="errorClass">Enter <b>email</b></span>
                            )}

                            {errors.email && (errors.email.type === "pattern") && (
                                <span className="errorClass">
                                    Email must be a valid email address
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocalPhone sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="phone" name="phone" label="Phone Number" variant="standard" sx={{ width: '100%' }}
                                    {...register('phone', { required: true, pattern: PHONE_REGEX, maxLength: 12 })}
                                    onChange={handlePhoneChange} //Added newly
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.phone && errors.phone.type === "required" && (
                                <span className="errorClass">Enter <b>phone number</b>
                                </span>
                            )}
                            {errors.phone && (errors.phone.type === "pattern" || errors.phone.type === "maxLength") && (
                                <span className="errorClass">
                                    Please enter a valid 10-digit <b>phone number</b>
                                </span>
                            )}
                        </Grid>

                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Apartment sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="address" name="address" label="Mailing Address" variant="standard" sx={{ width: '90%' }}
                                    {...register('address', { required: true })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.address && errors.address.type === "required" && (
                                <span className="errorClass">Enter <b>mailing address</b>
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocationCity sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="city" name="city" label="City" variant="standard" sx={{ width: '100%' }}
                                    {...register('city', { required: true })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.city && errors.city.type === "required" && (
                                <span className="errorClass">Enter <b>city</b>
                                </span>
                            )}
                        </Grid>

                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Email sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="zipCode" name="zipCode" label="Zip Code" variant="standard" sx={{ width: '90%' }}
                                    {...register('zipCode', { required: true, pattern: ZIP_REGEX, maxLength: 5 })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>

                            {/* use role="alert" to announce the error message */}
                            {errors.zipCode && errors.zipCode.type === "required" && (
                                <span className="errorClass">Enter <b>zip code</b></span>
                            )}
                            {errors.zipCode && (errors.zipCode.type === "pattern" || errors.zipCode.type === "maxLength") && (
                                <span className="errorClass">
                                    Zip code should contain only digit, Zip code must be 5-digit
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Grid container spacing={0} style={{ marginTop: '15px' }}>
                                    <Grid item xs={5.8}>
                                        <div className="regInfoMsg">
                                            Directly funded charter school
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl style={{ color: '#003c68', fontSize: '16px' }}>
                                            <RadioGroup
                                                row
                                                aria-labelledby="radio-buttons-group-label"
                                                defaultValue="no"
                                                name="directlyFunded"
                                                onChange={handleDFChange}>
                                                <FormControlLabel value="yes" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#3f51b5',
                                                    },
                                                }} />} label="Yes"
                                                    {...register("directlyFunded")}
                                                />
                                                <FormControlLabel value="no" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#f44336',
                                                    },
                                                }} />} label="No"
                                                    {...register("directlyFunded")}
                                                />
                                                <FormControlLabel value="both" control={<Radio sx={{
                                                    '&.Mui-checked': {
                                                        color: '#ff4081',
                                                    },
                                                }} />} label="Both"
                                                    {...register("directlyFunded")}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                </Grid>


                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Language sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 1.5 }} />
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <InputLabel id="county-label" sx={{ color: '#003c68' }}>Select a county</InputLabel>
                                    <Select
                                        labelId="county"
                                        id="county"
                                        label='Select a county'
                                        sx={{ width: '95%' }}
                                        // value={countyValue ? countyValue : ""}
                                        value={countyValue || ""}
                                        {...register("county", { required: true })}
                                        onChange={oncountyChange}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                    >
                                        <MenuItem value="">
                                            <em>Select a county</em>
                                        </MenuItem>
                                        {sortedCountyList.map((cVal, cKey) => (
                                            <MenuItem key={cVal._id} value={cVal._id}>{cVal.name}</MenuItem>
                                        ))}
                                        {/* <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem> */}
                                    </Select>

                                </FormControl>

                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.county && errors.county.type === "required" && (
                                countyValue ? '' : <span className="errorClass">Select a <b>county</b></span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <LocationCity sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 1.5 }} />
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                    <InputLabel id="district-label" sx={{ color: '#003c68' }}>Select a district</InputLabel>
                                    <Select
                                        labelId="district-label"
                                        id="district"
                                        name='district'
                                        label="Select a district"
                                        value={distValue || ""}
                                        sx={{ width: '100%' }}
                                        {...register("district", { required: true })}
                                        onChange={onDistChange}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                                    >
                                        <MenuItem value="">
                                            <em>Select a district</em>
                                        </MenuItem>

                                        {distList.map((dVal, dKey) => (
                                            <MenuItem key={dVal._id} value={dVal._id}>{dVal.name}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.district && errors.district.type === "required" && (
                                distValue ? '' : <span className="errorClass">Select a <b>district</b></span>
                            )}
                        </Grid>

                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Lock sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="password" name="password" label="Password" variant="standard" sx={{ width: '90%' }} type="password"
                                    {...register('password', { required: true, pattern: PASSWORD_NAME_REGEX })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>

                            {/* use role="alert" to announce the error message */}
                            {errors.password && errors.password.type === "required" && (
                                <span className="errorClass">Enter a <b>password</b></span>
                            )}
                            {errors.password && (errors.password.type === "pattern") && (
                                <span className="errorClass">
                                    Password must contain at least one number, one lowercase letter, and one uppercase letter, and be between 6 and 15 characters long.
                                </span>
                            )}
                        </Grid>
                        <Grid item xs={4.30}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Lock sx={{ color: '#003c68', fontSize: '20px', mr: 0.5, my: 0.5 }} />
                                <TextField id="cpassword" name="cpassword" label="Confirm Password" variant="standard" sx={{ width: '100%', color: "#003c68" }} type="password"
                                    {...register('cpassword', {
                                        required: true,
                                        validate: (value) => {
                                            if (watch('password') !== value)
                                                return "Your passwords do no match";
                                        }
                                    })}
                                    InputLabelProps={{
                                        style: { color: "#003c68" }
                                    }}
                                />
                            </Box>
                            {/* use role="alert" to announce the error message */}
                            {errors.cpassword && errors.cpassword.type === "required" && (
                                <span className="errorClass">Enter a <b>matching Password</b></span>
                            )}

                            {/* use role="alert" to announce the error message */}
                            {errors.cpassword && (
                                <span className="errorClass">Passwords do not match</span>
                            )}


                        </Grid>

                    </Grid>

                    <Grid container
                        spacing={0}
                        style={{ marginTop: '40px' }}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                        <Grid item xs={12}>
                            <Button type="submit" className='signup' sx={{
                                textAlign: 'center', height: 40, backgroundColor: '#003c68',
                                width: 620, borderRadius: 25, color: '#fff', ':hover': {
                                    bgcolor: '#003c68',
                                    color: 'white',
                                },
                            }}
                            >Create an account</Button>
                        </Grid>

                    </Grid>

                    <Grid container spacing={0} style={{ marginTop: '15px' }}>
                        <Grid item xs={1.74}></Grid>
                        <Grid item xs={8.8}>
                            <div className="regInfoMsg">
                                Once your account has been created, your CalSCHLS TA must approve your account before you can begin registering
                                for the survey. You will be sent an email once your account has been approved.
                            </div>
                        </Grid>
                    </Grid>
                </Box >
            </form>
        </>

    )
}

export default Register